var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 274 253.7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.1 253.7c45.3 0 82.1-36.7 82.1-82.1 0-45.3-36.7-82-82.1-82C36.7 89.6 0 126.3 0 171.6c0 45.3 36.7 82.1 82.1 82.1z",
    fill: "#04E061"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224.4 243.3c27.4 0 49.6-22.2 49.6-49.6s-22.2-49.6-49.6-49.6-49.6 22.2-49.6 49.6 22.2 49.6 49.6 49.6z",
    fill: "#FF4053"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8 78.9c16.9 0 30.7-13.7 30.7-30.7S114.7 17.5 97.8 17.5c-16.9 0-30.7 13.7-30.7 30.7s13.7 30.7 30.7 30.7z",
    fill: "#965EEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.2 133.4c36.8 0 66.7-29.9 66.7-66.7C271.9 29.9 242 0 205.2 0c-36.8 0-66.8 29.9-66.8 66.7 0 36.9 29.9 66.7 66.8 66.7z",
    fill: "#00AAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvito);
export default __webpack_public_path__ + "static/media/avito.019062d3dcafca85c84271bf32ce4384.svg";
export { ForwardRef as ReactComponent };